import { render, staticRenderFns } from "./AddressConfirmationModal.vue?vue&type=template&id=537a572c&scoped=true&"
import script from "./AddressConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./AddressConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressConfirmationModal.vue?vue&type=style&index=0&id=537a572c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a572c",
  null
  
)

export default component.exports